export default "__VITE_ASSET__BTae1hbq__"